import { CanActivateFn } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { inject } from '@angular/core'

export const superAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)

  console.log('🛡️ Super Admin Guard Check:', {
    isSuperAdmin: authService.isSuperAdmin$.value,
    isAuthenticated: authService.isAuthenticated$.value,
    accessToken: authService.accessToken ? 'Present' : 'Missing',
    route: route.routeConfig?.path,
  })

  return authService.isSuperAdmin$.value
}
